import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { ConnectorService } from '../../../Services/Connector/connector.service';
import { NbDialogService } from '@nebular/theme';
import { PlanificationDialogComponent } from '../planification-dialog/planification-dialog.component';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { FileUploadModalComponent } from '../../file-upload-modal/file-upload-modal.component';
import { ExecutingRequestComponent } from '../../executing-request/executing-request.component';
import { SuccessHandlerService } from '../../../Services/successHandler/success-handler.service';
import { ErrorHandlerService } from '../../../Services/errorHandler/error-handler.service';
import { ReportComponent } from '../../report/report.component';
import { ReportService } from '../../../Services/report/report.service';
import { PurgeReportsComponent } from '../../purge-reports/purge-reports.component';

@Component({
  selector: 'ngx-sub-component',
  templateUrl: './sub-component.component.html',
  styleUrls: ['./sub-component.component.scss']
})
export class SubComponentComponent implements OnInit {
    @Output() launch = new EventEmitter();
    @Output() stop = new EventEmitter();
    @Output() updateRecipients = new EventEmitter();
    /** an input for the current service */
    @Input() connector: any;

    /** connector logs */
    logs: any

    /** Alert users connector id */
    alertUserId : string = environment.alertUserId;

    /** Import users connector id */
    IMPORT_LDAP_ID: string = environment.IMPORT_LDAP_ID;

    organization_id= environment.ORGANIZATION_ID;

    /** a variable to check if a connector is running or not */
    // is_running: boolean;

    /** a variable for storing the connector's status */
    // status: boolean;

    /** connector reports */
    reports: any

  constructor(private connectorService: ConnectorService, private dialogService: NbDialogService, private router: Router,
    private successHandler: SuccessHandlerService, private errorHandler: ErrorHandlerService,
    private reportService: ReportService
  ){
  }

  ngOnInit(): void {
    this.reportService.getConnectorReports(this.organization_id, this.connector.connector_id).subscribe((response) => {
      this.reports = response;
    });

    this.connectorService.getLogs(this.organization_id, this.connector.connector_id).subscribe((response) => {
      this.logs = response;
    })
  }

  getConnector(){
    const data = this.connectorService.getConnector(this.organization_id, this.connector.connector_id);
  }

  getstatusString(status: number){
    switch (status){
      case 0:
        return 'erreur'
      case 1:
        return 'OK';

    }
  }

  planify(){
    this.dialogService.open(PlanificationDialogComponent,
      {
        context: {
          connector: this.connector,
        },
      }
    ).onClose.subscribe((formData) => {
      console.log(formData)
    })
  }

  getConnectorLogs(){
    this.connectorService.getLogs(this.organization_id, this.connector.connector_id).subscribe((response) => {
      this.logs = response;
    })

  }

  navigateToUserRoute(){
    this.router.navigate(['/', 'admin','config','admin-users']);
  }

  uploadFile(){
    this.dialogService.open(FileUploadModalComponent)
    .onClose.subscribe((file) => {
      if(file){
        let dialogRef = this.showExecutingOperationModal(`Envoie du fichier en cours ...`);
        this.connectorService.uploadFile(this.organization_id, file).subscribe((response) =>{
          dialogRef.close();
          this.successHandler.handleSuccess('Opération terminée avec succès.')
        }, error =>{
          dialogRef.close();
          this.errorHandler.handleError(error)
        });
      }
    })
  }

  showReports(){
    this.dialogService.open(ReportComponent,{
      context: {
        connector: this.connector,
        reports: this.reports,
      }
    });
  }

  purgeReports(){
    this.dialogService.open(PurgeReportsComponent).onClose.subscribe(formData => {
      if(formData){
        let dialogRef = this.showExecutingOperationModal(`Nettoyage des rapports en cours ...`);
        this.reportService.purgeReports(this.organization_id, this.connector.connector_id, formData.numberOfReportsToKeep).subscribe(deletedReports =>{
          dialogRef.close();
          this.successHandler.handleSuccess(`${deletedReports} rapport(s) ont été supprimés avec succès`);
        }, error =>{
          dialogRef.close();
          this.errorHandler.handleError(error)
        });
      }
    })
  }

   /**
   *   a function that opens a pop-up when an operation is executing
   */
   showExecutingOperationModal(message: string){
    return this.dialogService.open(ExecutingRequestComponent, {
      context: {
        message
      },
      closeOnBackdropClick: false,  // Désactive la possibilité de fermer en cliquant en dehors du dialogue
    });
  }

}
